<p-dialog [(visible)]="laborShift" [breakpoints]="{ '960px': '50vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'clock']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">{{ laborShift.name || 'New Shift' }}</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<ng-template pTemplate="content">
		<div class="p-grid">
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4">
					<input
						pInputText
						#shiftNameInput
						name="shiftNameInput"
						type="text"
						[(ngModel)]="laborShift.name"
						class="w-100"
						(ngModelChange)="changesToSave = true"
					/>
					<label for="shiftNameInput">Shift Name</label>
				</span>
			</div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4">
					<p-dropdown
						#shiftJobSelect
						[options]="jobList"
						optionLabel="name"
						optionValue="id"
						name="shiftJobSelect"
						[(ngModel)]="laborShift.jobId"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						itemSize="30"
						filter="true"
						(filterBy)="app.keys(jobList)"
						(onchange)="setShiftJob($event)"
						(ngModelChange)="changesToSave = true"
					></p-dropdown>
					<label for="shiftJobSelect">Job</label>
				</span>
			</div>
			<div class="p-col-12 p-sm-4 d-flex">
				<div class="w-100 mt-4 d-flex">
					<div>
						<p-colorPicker #shiftColorInput (ngModelChange)="changesToSave = true" [(ngModel)]="laborShift.color"> </p-colorPicker>
					</div>
				</div>
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col-12 p-sm-3">
				<div>
					<span class="p-float-label mt-4">
						<p-calendar
							#shiftStartTimeInput
							[(ngModel)]="laborShift.startTime"
							dataFormat
							(ngModelChange)="shiftTimeChange(); changesToSave = true"
							[timeOnly]="true"
							appendTo="body"
							dataType="string"
						></p-calendar>
						<label for="shiftStartTimeInput">Start Time</label>
					</span>
				</div>
			</div>
			<div class="p-col-12 p-sm-3">
				<div>
					<span class="p-float-label mt-4">
						<p-calendar
							#shiftStartTimeInput
							[(ngModel)]="laborShift.endTime"
							(ngModelChange)="shiftTimeChange()"
							[timeOnly]="true"
							appendTo="body"
							dataType="string"
						></p-calendar>
						<label for="shiftStartTimeInput">End Time</label>
					</span>
				</div>
				<div *ngIf="endTimeAlert">
					<small class="text-italics text-red">{{ endTimeAlert }}</small>
				</div>
				<div *ngIf="shiftMinutes > 0 && !endTimeAlert" class="text-center">
					{{ app.moment.duration(shiftMinutes, 'minutes').format('h [hrs], m [min]') }}
				</div>
			</div>
			<div class="p-col-12 p-sm-6">
				<span class="p-float-label mt-4">
					<textarea pInputTextarea #shiftNoteInput name="shiftNoteInput" [(ngModel)]="laborShift.note" class="w-100 mt-1"></textarea>
					<label for="shiftNoteInput">Shift Notes</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			(onCancelChange)="back()"
			(onDeleteChange)="delete()"
			(onSaveChange)="save()"
			[deleteDisabled]="validateDelete()"
			[saveDisabled]="validateSave()"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
